import React, { useEffect, useState } from 'react'
import CategoryPopup from './category-popup' // Adjust the path as necessary
import Button from '../Button' // Adjust the path as necessary
import PTRestAPI from '../../utils/pt_rest_api' // Adjust the path as necessary
import { useAuth } from '../../utils/platform_auth.jsx'

const Chip = ({ category, onRemove }) => (
  <div className="mr-2 p-3 flex text-text items-center bg-canvas border border-bordered rounded">
    <span>{category.title}</span>
    <button
      className="ml-4 text-text"
      onClick={() => onRemove(category.categoryID)}
    >
      x
    </button>
  </div>
)

let isFetching = false

const CategorySelector = ({ controller, onSelect }) => {
  const [selectedCategories, setSelectedCategories] = useState([])
  const [popupOpen, setPopupOpen] = useState(false)
  const auth = useAuth()

  //resolve the categories from the article
  useEffect(() => {
    const fetchCategories = async () => {
      if (isFetching) return
      if (
        !controller.articlePayload ||
        !controller.articlePayload.categoryID ||
        !controller.articlePayload.categoryID.length
      ) {
        setSelectedCategories([])
        return
      }

      isFetching = true
      const selected = controller.articlePayload.categoryID

      try {
        const data = await PTRestAPI.ListCategories(auth, {
          match: { categoryID: { $in: selected } },
        })
        setSelectedCategories(data.categories)
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
      isFetching = false
    }

    fetchCategories()
  }, [controller.publishOpen])

  const handleCategorySelect = (categories) => {
    setSelectedCategories(categories)
  }
  const handleRemoveCategory = (categoryID) => {
    setSelectedCategories((prevCategories) =>
      prevCategories.filter((cat) => cat.categoryID !== categoryID),
    )
  }

  useEffect(() => {
    onSelect(selectedCategories)
  }, [selectedCategories])

  return (
    <div className="flex flex-col">
      <label className="text-text font-bold mr-2 mb-2">Categories</label>
      <div className="flex flex-row gap-2 items-center">
        <div className="overflow-x-auto items-center w-full flex flex-row justify-start">
          {selectedCategories.map((category) => (
            <Chip
              key={category.categoryID}
              category={category}
              onRemove={handleRemoveCategory}
            />
          ))}
        </div>
        <Button
          variant="action"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setPopupOpen(true)
          }}
          className="ml-2 bg-primary text-white"
        >
          Select
        </Button>
      </div>

      {popupOpen && (
        <CategoryPopup
          onClose={() => setPopupOpen(false)}
          onSelect={handleCategorySelect}
          selectedCategories={selectedCategories}
        />
      )}
    </div>
  )
}

export default CategorySelector
